import { FoldedCollection, Result } from '@coveo/headless';
import { ResultLink } from '../ResultLink';
import { HighlightedText } from '../HighlightedText';
import { Grid } from '@mui/material';

export interface ISitecoreProductGuideResultsProps {
  collection: FoldedCollection;
}
export function SitecoreProductGuideResults({ collection }: ISitecoreProductGuideResultsProps) {
  function getDate(result: Result, fieldName: string) {
    if (result.raw.hasOwnProperty(fieldName)) {
      const date: Date = new Date(result.raw[fieldName] as string);
      return date.toLocaleDateString();
    }
    return '';
  }
  function renderDates(result: Result) {
    return (
      <Grid container className="result-date caption">
        <Grid size={{ xs: 6 }}>{'Modified Date: ' + getDate(result, 'updated')}</Grid>
        <Grid size={{ xs: 6 }}>{'Created Date: ' + getDate(result, 'created')}</Grid>
      </Grid>
    );
  }
  return (
    <article className="result-folding-result">
      <div className="result-folding-title">
        <ResultLink result={collection.result} target="_blank">
          <HighlightedText value={collection.result.title} highlights={collection.result.titleHighlights} />
        </ResultLink>
      </div>
      {renderDates(collection.result)}
    </article>
  );
}
